import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/quotes")({
  head: () => ({ meta: [{ title: "Quote Requests | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-quotes")),
});
